export default __webpack_public_path__ + "static/nicolas-horn-MTZTGvDsHFY-unsplash (1)-90fca07ac362ed196e4c9ce1c9afebe6.jpg";